<div class="detail-container">
  <nb-card [nbSpinner]="!!(loading$|async)">
    <nb-card-header>
      <button nbButton ghost status="primary" (click)="navigateBack()">
        <nb-icon pack="eva" icon="arrow-back-outline"></nb-icon>
      </button>
      <h5>Bereich</h5>
      <wr-edit-delete-button-group *ngIf="canEdit() && !isNew()" (edit)="onEdit()" (delete)="onDelete()"></wr-edit-delete-button-group>
    </nb-card-header>
    <nb-card-body>
      <ng-container *ngIf="form">
        <nb-tabset>
          <nb-tab tabTitle="Details">
            <hau-form [formGroup]="form">
              <hau-form-field label="Name" [validation]="form.validation.name" cols="6">
                <input nbInput fullWidth formControlName="name">
              </hau-form-field>
              <hau-form-field label="Kürzel" [validation]="form.validation.abbreviation" cols="6">
                <input nbInput fullWidth formControlName="abbreviation">
              </hau-form-field>
              <hau-form-field label="Farbe" [validation]="form.validation.color" cols="6">
                <wr-color-preset-picker formControlName="color"></wr-color-preset-picker>
              </hau-form-field>
              <hau-form-field label="Leiter*in" [validation]="form.validation.leader" cols="6">
                <wr-user-select [formControl]="form.controls.leader" [tenantIds$]="tenantFilter$"></wr-user-select>
              </hau-form-field>
              <hau-form-field label="Beschreibung" [validation]="form.validation.description" cols="6">
                <textarea nbInput fullWidth formControlName="description"></textarea>
              </hau-form-field>
            </hau-form>
          </nb-tab>
          <nb-tab tabTitle="Teams" *ngIf="!isNew()">
            <hau-form [formGroup]="form">
              <hau-form-field>
                <wr-team-pick-list
                  [getAssignmentTypeFunction]="assignmentTypeFunction"
                  [regionId]="regionId"
                  formControlName="teams">
                </wr-team-pick-list>
              </hau-form-field>
            </hau-form>
          </nb-tab>
        </nb-tabset>
      </ng-container>
    </nb-card-body>
    <nb-card-footer *ngIf="canEdit()">
      <button size="medium" [disabled]="!isEditing" nbButton status="primary" (click)="submit()">Speichern</button>
      <button size="medium" [disabled]="!isEditing" nbButton status="basic" (click)="cancel()">Zurück</button>
    </nb-card-footer>
  </nb-card>
</div>
